import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["zipCode", "city", "state", "street", "neighborhood", "complement"];

  connect() {
    // this.zipCodeTarget.addEventListener("input", this.consultCEP.bind(this));
    this.streetElement =  this.streetTarget.parentElement.querySelector('.input-loading');
    this.neighborhoodElement =  this.neighborhoodTarget.parentElement.querySelector('.input-loading');
    this.complementElement =  this.complementTarget.parentElement.querySelector('.input-loading');
  }

  async consultCEP(event) {
    let zipCode = event.currentTarget.value;
    let cep = zipCode.replace(/\D/g, "");
    console.log(cep.length);
    if (cep.length == 9) return;
    
    if (cep.length != 8){
      this.resetFields();
      return;
    }

    this.addClassLoading();

    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();

    if (response.ok) {
      this.removeClassLoading();
      if (data.erro) {
        console.log("CEP not found");

        return;
      }

      console.log(data);
      this.setStateAndCity(data.uf, data.localidade);
      this.streetTarget.value = data.logradouro;
      this.neighborhoodTarget.value = data.bairro;
      this.complementTarget.value = data.complemento;
    } else {
      this.removeClassLoading();
    }
  }

  setStateAndCity(uf, city) {
    const options = this.stateTarget.children;
    for (let i = 0; i < options.length; i++) {
      if (options[i].dataset.code === uf) {
        options[i].selected = true;
        this.loadCities(options[i], city);
        break;
      }
    }
  }

  setCity(city) {
    console.log(city);
    const options = this.cityTarget.children;
    for (let i = 0; i < options.length; i++) {
      if (options[i].textContent.toLowerCase() === city.toLowerCase()) {
        console.log(options[i].textContent);
        console.log(city);
        options[i].selected = true;
      }
    }
  }

  async loadCities(selectedOption, city) {
    const cities = await this.fetchCities(selectedOption);
    this.cityTarget.readonly = cities.length == 0 ;
    this.cityTarget.innerHTML = cities.length > 0 ? `<option>Selecione a cidade</option>${cities.map(city => `<option value="${city.id}">${city.name}</option>`).join('')}` : '';
    this.setCity(city);
  }

  async fetchCities(selectedOption) {
    console.log(selectedOption);
    const dataUrl = selectedOption.getAttribute('data-url');
    if (dataUrl == null) {
      this.cityTarget.value = null;
      return [];
    }

    const response = await fetch(dataUrl)
    return await response.json();
  }

  resetFields() {
    this.cityTarget.value = "";
    this.stateTarget.value = "";
    this.streetTarget.value = "";
    this.neighborhoodTarget.value = "";
    this.complementTarget.value = "";
  }

  addClassLoading() {
    this.neighborhoodElement.classList.add('flex');
    this.neighborhoodElement.classList.remove('hidden');
    this.streetElement.classList.add('flex');
    this.streetElement.classList.remove('hidden');
    this.complementElement.classList.add('flex');
    this.complementElement.classList.remove('hidden');
  }

  removeClassLoading() {
    this.neighborhoodElement.classList.add('hidden');
    this.streetElement.classList.add('hidden');
    this.complementElement.classList.add('hidden');
  }
}